import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import AboutSection from "@/components/landing/AboutSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import ModesSection from "@/components/landing/ModesSection";
import PodcastTeaser from "@/components/landing/PodcastTeaser";
import PhilosophySection from "@/components/landing/PhilosophySection";
import TestimonialCTA from "@/components/landing/TestimonialCTA";
import Footer from "@/components/landing/Footer";
import SEO, { organizationSchema, websiteSchema, softwareAppSchema } from "@/components/SEO";
import { markVisited } from "@/hooks/useInView";

export default function LandingPage() {
  useEffect(() => {
    markVisited();
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F8F9FB]">
      <SEO
        description="NeuroNest helps neurodivergent individuals navigate daily life with calming tools, visual routines, communication cards, and 1,370+ sensory-friendly places. No scores. No streaks. No pressure."
        path="/"
        jsonLd={[organizationSchema, websiteSchema, softwareAppSchema()]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <FeaturesSection />
        <ModesSection />
        <PodcastTeaser />
        <PhilosophySection />
        <TestimonialCTA />
      </main>
      <Footer />
    </div>
  );
}
